import React from "react";
import { Typography } from "@material-ui/core";

interface ErrorProps {
  message: string;
  campaignRequestId?: string;
  statusCode?: number;
}
const Error: React.FC<ErrorProps> = (props: ErrorProps) => {
  return (
    <React.Fragment>
      <Typography variant="h5">{props.message}</Typography>
      <br />
      <Typography variant="subtitle1">{`REQUEST ID: ${props.campaignRequestId}`}</Typography>
      <Typography variant="subtitle1">{`STATUS_CODE: ${props.statusCode}`}</Typography>
    </React.Fragment>
  );
};

export default Error;
